import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Users, Share2, CheckCircle, X } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PadelMatchsOuvertsPage = () => {
  const [lightboxImage, setLightboxImage] = useState(null);

  const openLightbox = (src, alt) => {
    setLightboxImage({ src, alt });
  };

  const closeLightbox = () => {
    setLightboxImage(null);
  };
  const steps = [
    {
      number: 1,
      title: "Renseignez votre niveau",
      description: "Allez dans votre Profil pour sélectionner votre niveau de padel. C'est indispensable pour que le système sache si vous avez le droit de jouer.",
      image: "https://s3-eu-central-1.amazonaws.com/euc-cdn.freshdesk.com/data/helpdesk/attachments/production/204018272982/original/OnM1agT_TVJ8BaPoJa_jYVsHxNvUDE2uTA.png?1767970729",
      color: "from-blue-500 to-cyan-600"
    },
    {
      number: 2,
      title: "Créez un match ouvert",
      description: "Cliquez sur un créneau. Laissez des lignes 'Personne' vides pour les places disponibles. Payez votre part et cliquez sur le bouton vert CRÉER UNE RÉSERVATION OUVERTE.",
      image: "https://s3-eu-central-1.amazonaws.com/euc-cdn.freshdesk.com/data/helpdesk/attachments/production/204018272989/original/hnARSWVx0WnFfRPoZNjDACnvSbVWMATP1g.png?1767970735",
      color: "from-green-500 to-emerald-600"
    },
    {
      number: 3,
      title: "Invitez des joueurs",
      description: "Le match apparaît avec une icône spécifique. Cliquez dessus puis utilisez le bouton WhatsApp pour envoyer le lien d'invitation à votre groupe.",
      image: "https://s3-eu-central-1.amazonaws.com/euc-cdn.freshdesk.com/data/helpdesk/attachments/production/204018273001/original/O3B-8nHi6W-Y59Pqc6bLq3Qmk6n5pWF3hg.png?1767970744",
      color: "from-orange-500 to-red-600"
    },
    {
      number: 4,
      title: "Rejoignez un match ouvert",
      description: "Le joueur invité clique sur le créneau. Il clique sur une place libre ('Personne'), sélectionne son nom, et paie uniquement sa part pour valider sa présence.",
      image: "https://s3-eu-central-1.amazonaws.com/euc-cdn.freshdesk.com/data/helpdesk/attachments/production/204018273003/original/VTJQ4D0IkLXp2cO73SJalqhbNTVCXXx8ZA.png?1767970750",
      color: "from-purple-500 to-pink-600"
    }
  ];

  const findMatchSteps = [
    {
      number: 1,
      title: "Voir les matchs disponibles",
      description: "Dans le menu de gauche, cliquez sur Réservations disponibles. Vous verrez la liste de tous les matchs ouverts qui cherchent des joueurs de votre niveau.",
      image: "https://s3-eu-central-1.amazonaws.com/euc-cdn.freshdesk.com/data/helpdesk/attachments/production/204018276938/original/s14Sr-qSp3ruEmF4fusapPd7XFM4tFngpA.png?1767973141",
      color: "from-indigo-500 to-purple-600"
    },
    {
      number: 2,
      title: "Rejoindre une partie",
      description: "Cliquez sur le bouton Rejoindre le match (ou l'icône '+') pour voir les détails de la partie et qui joue déjà.",
      image: "https://s3-eu-central-1.amazonaws.com/euc-cdn.freshdesk.com/data/helpdesk/attachments/production/204018276939/original/clG1LWHCmzFaWGFhdOMzMSRJe1uGAoAORA.png?1767973148",
      color: "from-teal-500 to-cyan-600"
    },
    {
      number: 3,
      title: "S'inscrire et payer",
      description: "Cliquez sur une ligne libre ('Personne'), sélectionnez votre nom, et payez votre part. Le match est confirmé !",
      image: "https://s3-eu-central-1.amazonaws.com/euc-cdn.freshdesk.com/data/helpdesk/attachments/production/204018276943/original/F2hy5Q9C-Z4KVW8CbZWdq5hkvHktsa6NTw.png?1767973157",
      color: "from-pink-500 to-rose-600"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header scrollY={100} />
      
      {/* Lightbox Modal */}
      {lightboxImage && (
        <div 
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={closeLightbox}
        >
          <button
            onClick={closeLightbox}
            className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors"
          >
            <X className="w-10 h-10" />
          </button>
          <img
            src={lightboxImage.src}
            alt={lightboxImage.alt}
            className="max-w-full max-h-[90vh] object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
      
      <div className="pt-24 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/padel" className="inline-flex items-center text-green-600 hover:text-green-700 mb-8 transition-colors">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Retour à la page Padel
          </Link>
          
          <div className="mb-12">
            <div className="inline-block bg-orange-500 text-white px-3 py-1 rounded-full text-sm font-semibold mb-4">
              🆕 NOUVEAU
            </div>
            <h1 className="text-5xl font-bold text-gray-900 mb-4">
              Matchs Ouverts : Trouvez des partenaires facilement
            </h1>
            <p className="text-xl text-gray-600">
              Plus besoin de trouver automatiquement 4 joueurs pour lancer une partie. 
              Ouvrez un match, partagez-le, et d'autres personnes peuvent le rejoindre !
            </p>
          </div>

          {/* Avantages */}
          <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-8 rounded-2xl mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Pourquoi utiliser les matchs ouverts ?</h2>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="flex items-start gap-3">
                <CheckCircle className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Jouez quand vous voulez</h3>
                  <p className="text-gray-700 text-sm">Pas besoin d'attendre d'avoir 4 joueurs pour réserver</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Users className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Rencontrez de nouveaux joueurs</h3>
                  <p className="text-gray-700 text-sm">Élargissez votre réseau de partenaires de jeu</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Share2 className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Partagez facilement</h3>
                  <p className="text-gray-700 text-sm">Envoyez le lien via WhatsApp en un clic</p>
                </div>
              </div>
            </div>
          </div>

          {/* Étapes */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">Comment ça marche ?</h2>
            
            <div className="space-y-8">
              {steps.map((step) => (
                <div key={step.number} className="bg-white rounded-2xl shadow-lg overflow-hidden">
                  <div className={`h-2 bg-gradient-to-r ${step.color}`}></div>
                  <div className="p-6 md:flex md:items-start md:gap-8">
                    <div className="flex-1 mb-6 md:mb-0">
                      <div className="flex items-center gap-3 mb-4">
                        <div className={`w-12 h-12 rounded-full bg-gradient-to-br ${step.color} flex items-center justify-center flex-shrink-0`}>
                          <span className="text-white font-bold text-xl">{step.number}</span>
                        </div>
                        <h3 className="text-2xl font-bold text-gray-900">{step.title}</h3>
                      </div>
                      <p className="text-gray-700 leading-relaxed text-lg">
                        {step.description}
                      </p>
                    </div>
                    <div className="flex-shrink-0 md:w-80">
                      <img 
                        src={step.image}
                        alt={step.title}
                        className="w-full rounded-lg shadow-md border border-gray-200 cursor-pointer hover:shadow-xl transition-shadow"
                        onClick={() => openLightbox(step.image, step.title)}
                      />
                      <p className="text-center text-sm text-gray-500 mt-2">
                        Cliquez pour agrandir
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Section Trouver et Rejoindre */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">Trouver et Rejoindre un Match</h2>
            
            <div className="space-y-8">
              {findMatchSteps.map((step) => (
                <div key={step.number} className="bg-white rounded-2xl shadow-lg overflow-hidden">
                  <div className={`h-2 bg-gradient-to-r ${step.color}`}></div>
                  <div className="p-6 md:flex md:items-start md:gap-8">
                    <div className="flex-1 mb-6 md:mb-0">
                      <div className="flex items-center gap-3 mb-4">
                        <div className={`w-12 h-12 rounded-full bg-gradient-to-br ${step.color} flex items-center justify-center flex-shrink-0`}>
                          <span className="text-white font-bold text-xl">{step.number}</span>
                        </div>
                        <h3 className="text-2xl font-bold text-gray-900">{step.title}</h3>
                      </div>
                      <p className="text-gray-700 leading-relaxed text-lg">
                        {step.description}
                      </p>
                    </div>
                    <div className="flex-shrink-0 md:w-80">
                      <img 
                        src={step.image}
                        alt={step.title}
                        className="w-full rounded-lg shadow-md border border-gray-200 cursor-pointer hover:shadow-xl transition-shadow"
                        onClick={() => openLightbox(step.image, step.title)}
                      />
                      <p className="text-center text-sm text-gray-500 mt-2">
                        Cliquez pour agrandir
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Information importante */}
          <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-lg mb-12">
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0">
                <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <p className="font-semibold text-blue-900 mb-1">Information importante</p>
                <p className="text-blue-800">
                  Si 3h avant le début du match il n'y a pas 4 personnes inscrites, le match sera automatiquement annulé sans frais.
                </p>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="bg-gradient-to-br from-orange-500 to-red-600 text-white p-12 rounded-3xl text-center">
            <h2 className="text-3xl font-bold mb-6">Prêt à rejoindre un match ?</h2>
            <p className="text-white/90 mb-8 text-lg">
              Connectez-vous sur la plateforme de réservation et découvrez les matchs ouverts disponibles !
            </p>
            <a 
              href="http://tccheyres.plugin.ch/user/dashboard"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-white text-orange-600 hover:bg-gray-100 px-8 py-4 rounded-xl font-semibold transition-all hover:scale-105"
            >
              Accéder à la plateforme
            </a>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PadelMatchsOuvertsPage;
